import { render, staticRenderFns } from "./InsuranceDetailResume.vue?vue&type=template&id=6acabbe2&scoped=true"
import script from "./InsuranceDetailResume.vue?vue&type=script&lang=js"
export * from "./InsuranceDetailResume.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDetailResume.vue?vue&type=style&index=0&id=6acabbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acabbe2",
  null
  
)

export default component.exports